/**
 * Card — Bra Game R1 primitive.
 * variants: default, elevated, bordered, glow (hover glow)
 */
export function Card({ variant = "default", className = "", children, ...rest }) {
  const base = "rounded-xl transition-all duration-200";
  const V = {
    default: "bg-elevated border border-line",
    elevated: "bg-highest border border-line shadow-card",
    bordered: "bg-transparent border border-line",
    glow: "bg-elevated border border-line hover:border-pink hover:shadow-glow-pink hover:-translate-y-0.5 cursor-pointer",
  };
  return (
    <div className={`${base} ${V[variant] || V.default} ${className}`} {...rest}>
      {children}
    </div>
  );
}

export function CardHeader({ className = "", children }) {
  return <div className={`px-5 pt-5 pb-3 ${className}`}>{children}</div>;
}
export function CardBody({ className = "", children }) {
  return <div className={`px-5 pb-5 ${className}`}>{children}</div>;
}
export function CardTitle({ className = "", children }) {
  return <div className={`font-display italic text-xl text-ink ${className}`}>{children}</div>;
}
export function CardLabel({ className = "", children }) {
  return <div className={`text-[10px] tracking-[0.25em] uppercase text-ink-2 ${className}`}>{children}</div>;
}
